/**
 * Panel de reglas, plegable y siempre accesible (MVP §6.4). El texto lo produce el pack
 * de contenido (`rulesFor`), incluida la nota de que ninguna sala se queda vacía: sin
 * ella el jugador lee «la primera en bajar al sótano» como algo más débil de lo que es.
 *
 * Es un `<details>` nativo a propósito: plegado accesible sin JavaScript ni ARIA a mano.
 */

import type { RulesText } from '@murdoku/content';

export function RulesPanel({ rules }: { rules: RulesText }) {
  return (
    <details className="border-border bg-surface rounded-lg border">
      <summary className="focus-ring font-display cursor-pointer list-none px-4 py-3 text-lg">
        {rules.title}
      </summary>
      <div className="text-text-muted flex flex-col gap-3 px-4 pb-4 text-sm leading-relaxed">
        <p>{rules.intro}</p>
        <ol className="flex list-decimal flex-col gap-2 pl-5">
          {rules.rules.map((rule) => (
            <li key={rule}>{rule}</li>
          ))}
        </ol>
        <p className="border-accent border-l-2 pl-3">{rules.note}</p>
      </div>
    </details>
  );
}
